import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import {
  // Button,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";

import { AREAS_USUARIOS, MENU_TIPO_EXPEDIENTE, MENU_TIPO_EXPEDIENTE_ARRAY, TIPO_EFECTORES } from '../../../utils/constants';
import { desSeleccionarContrato, setDataContrato } from '../../../actions/contrataciones/contrataciones';
import { cleanComprobantesMesaEntrada, cleanProformasMesaEntrada, setRecepcionMenu, setTipoComprobanteDocumentacionMenu, setTipoEfectorMenu } from '../../../actions/mesaEntrada/mesaEntradaActions';
import { setProveedor } from '../../../actions/compras/ProveedoresAction';
import { TIPO_COMPROBANTE_DOCUMENTO } from '../../../utils/constants';
import { COMPROBANTE_EMBARGO_ARRAY } from '../../../utils/constants';
import { cleanCuentasContables } from '../../../actions/contrataciones/contratacionesDatosContables';
import Buscador from '../../../actions/ui/Buscador';

const fechaActual = new Date();

export const ConsultaComprobantes = () => {
  const dispatch = useDispatch();

  const [value, setValue] = useState(null);
  const [tipoExpediente, setTipoExpediente] = useState(MENU_TIPO_EXPEDIENTE.PRESTADOR);
  const [idTipoEfector, setIdTipoEfector] = useState(TIPO_EFECTORES.CONTRATO_PRESTADORES);
  const [idTipoComprobanteDocumento, setIdTipoComprobanteDocumento] = useState(TIPO_COMPROBANTE_DOCUMENTO.DOCUMENTACION);

  const { tipoEfectores } = useSelector((state) => state.tipoSubtipoEfectores);
  const { areas } = useSelector(state => state.auth);
  const esRRHH = Boolean(areas?.find(x => x.idArea === AREAS_USUARIOS.RECURSOS_HUMANOS));

  const resetValues = () => {
    setValue(null);
  }

  const resetContrato = () => {
    dispatch(cleanComprobantesMesaEntrada());
    dispatch(cleanProformasMesaEntrada());
    dispatch(cleanCuentasContables());
    dispatch(desSeleccionarContrato());
    dispatch(setProveedor(null));
    dispatch(setRecepcionMenu(MENU_TIPO_EXPEDIENTE.DESELECCIONAR));
  }

  useEffect(() => {
    resetContrato();
    dispatch(setDataContrato(value));
    dispatch(setRecepcionMenu(tipoExpediente));
    dispatch(setTipoEfectorMenu(idTipoEfector));
    dispatch(setTipoComprobanteDocumentacionMenu(idTipoComprobanteDocumento));
  }, [value, tipoExpediente, idTipoComprobanteDocumento])
  

  return (
    <Grid item xs={12} sm={5} lg={4} xl={3}>
      <Grid
        container
        spacing={1}
        justify="center"
        alignItems="center"
        component={Card}
        style={{ marginTop: "2rem", marginBottom: "2rem", padding: "0 1em" }}
      >
        <Grid item xs={tipoExpediente === MENU_TIPO_EXPEDIENTE.PRESTADOR ? 6 : 12}>
          <FormControl variant="outlined" margin="normal" fullWidth={true}>
            <InputLabel id="demo-simple-select-outlined">
              Tipo de Expediente
            </InputLabel>
            <Select
              onChange={(e) => {
                resetValues();
                resetContrato();
                setIdTipoEfector(TIPO_EFECTORES.CONTRATO_PRESTADORES);
                setIdTipoComprobanteDocumento(TIPO_COMPROBANTE_DOCUMENTO.DOCUMENTACION);
                setTipoExpediente(parseInt(e.target.value));
              }}
              value={tipoExpediente}
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              label="Tipo de Contratación"
            >
              {MENU_TIPO_EXPEDIENTE_ARRAY.map((t, index) => (
                <MenuItem key={index} value={t.id}>
                  {t.descripcion}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {tipoExpediente === MENU_TIPO_EXPEDIENTE.PRESTADOR && (
          <Grid item xs={6}>
            <FormControl variant="outlined" margin="normal" fullWidth={true}>
              <InputLabel id="demo-simple-select-outlined">
                Tipo de Contratación
              </InputLabel>
              <Select
                onChange={(e) => {
                  resetValues();
                  resetContrato();
                  setIdTipoEfector(parseInt(e.target.value));
                }}
                value={idTipoEfector}
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                label="Tipo de Contratación"
              >
                {tipoEfectores.map((t, index) => (
                  <MenuItem key={index} value={t.idTipoEfector}>
                    {t.descripcionTipoEfector}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
        {tipoExpediente === MENU_TIPO_EXPEDIENTE.PRESTADOR && ( 
          <Grid item xs={12} style={{marginBottom: "1em"}}>
            <Buscador 
              value={value}
              variant="outlined"
              setValue={(val) => setValue(val)}
              label="Cod contrato  |  CUIT  |  Razón Social  |  Nombre Fantasia" 
              endpoint={(texto) => `EfectorFacturacion/BusquedaPorSp/${idTipoEfector}?buscador=${texto}`}
              noOptionText={"No se encuentra contrato"}
              getOptionLabel={(option) => (`${option.nombreFantasia.trim() || option.razonSocial.trim()} - ${option.cuit}`)}
              renderOption={(option) => (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span style={{color: option.fechaBaja === null || option.fechaBaja >= fechaActual.toISOString() ? "green" : "red"}}>
                    {`${option.nombreFantasia.trim() || option.razonSocial.trim()} - ${option.cuit} ${option.calleDomicilio && `- ${option.calleDomicilio}`} ${option.nroDomicilio && `- ${option.nroDomicilio}`}`}
                  </span>
                </div>
              )}
            />
          </Grid>
        )}
        {tipoExpediente === MENU_TIPO_EXPEDIENTE.DOCUMENTO && esRRHH && (
          <Grid item xs={12} style={{marginBottom: "1em"}}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel id="demo-simple-select-outlined">
                Tipo Comprobante Documento
              </InputLabel>
              <Select
                onChange={(e) => {
                  resetValues();
                  resetContrato();
                  setIdTipoComprobanteDocumento(parseInt(e.target.value));
                }}
                value={idTipoComprobanteDocumento}
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                label="Tipo Comprobante Documento"
                fullWidth
              >
                {COMPROBANTE_EMBARGO_ARRAY.map((t, index) => (
                  <MenuItem key={index} value={t.value}>
                    {t.descripcion}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
        {/* <Grid item>
          <Button
            style={{ margin: "0.5rem 0" }}
            variant="contained"
            color="primary"
            fullWidth
            disabled={tipoExpediente === MENU_TIPO_EXPEDIENTE.PRESTADOR ? !value : null}
            onClick={(e) => {
              submitHandler(e);
            }}
          >
            CONTINUAR
          </Button>
        </Grid> */}
      </Grid>
    </Grid>
  )
}
